import React from 'react';
import PropTypes from 'prop-types';
import { TouchableOpacity, Image } from 'react-native-web';

import styles from './styles';

/**
 * @typedef {string | {
 *  uri: string,
 *  height: number,
 *  width: number,
 * }} ImageSource
 */

/**
 * @typedef SportIconArrowProps
 * @property {ImageSource} imageSource
 * @property {() => void} onPress
 * @property {'left' | 'right'} variant
 */

/** @type React.FC<SportIconArrowProps> */
const SportIconArrow = ({ imageSource, variant, onPress }) => (
  <TouchableOpacity
    onPress={onPress}
    activeOpacity={1}
    style={[
      styles.sportChevronContainer,
      variant === 'left' ? styles.sportChevronContainerLeft : {},
      variant === 'right' ? styles.sportChevronContainerRight : {},
    ]}
  >
    <Image source={imageSource} alt={`Chevron ${variant}`} />
  </TouchableOpacity>
);

SportIconArrow.propTypes = {
  imageSource: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      uri: PropTypes.string,
      height: PropTypes.number,
      width: PropTypes.number,
    }),
  ]).isRequired,
  variant: PropTypes.oneOf(['left', 'right']).isRequired,
  onPress: PropTypes.func.isRequired,
};

export default SportIconArrow;
